import { RadioButtonColumnCustomFormField, RadioButtonRowCustomFormField, SuggesterCustomFormField, FileUploadCustomFormField, FreeTextCustomFormField, MatrixRadioButtonsFormField, CustomComponentCustomFormField } from "../CustomFormFields";
import { LocalizedText } from "../LanguageCode";
import { PermissionGroupId } from "../PermissionGroups";

export function isInputField(field: CustomFormField): field is CustomFormInputField {
    return InputFormFieldTypes.find(t => t === field.type) !== undefined;
}

export type CustomFormField = 
    CustomFormStaticField |
    CustomFormInputField |
    CustomFormLayout ;

export type CustomFormStaticField = 
    StaticTextCustomFormField |
    StaticTextImportantCustomFormField;


export type CustomFormInputField = 
    RadioButtonColumnCustomFormField |
    RadioButtonRowCustomFormField |
    SuggesterCustomFormField |
    FileUploadCustomFormField |
    FreeTextCustomFormField |
    MatrixRadioButtonsFormField |
    CustomComponentCustomFormField;

export type CustomFormLayout = 
    LayoutBreakBeforeCustomForm;


// ------------------------------------------
// Shared base for all form fields

type BaseFormField = {
    fieldId:string
}

// ------------------------------------------
// Shared base for markup fields

export const  LayoutFormFieldTypes = [ 'HtmlLayout' ] as const;
export type LayoutFormFieldType = typeof LayoutFormFieldTypes[number];

type BaseLayoutFormField = BaseFormField & {
    type:LayoutFormFieldType,
}


export type LayoutBreakBeforeCustomForm = BaseLayoutFormField & {
    type:'HtmlLayout'
    componentName:string,
}


// ------------------------------------------
// Shared base for Static (non-input) fields

export const StaticFormFieldTypes = [ 'StaticText', 'StaticTextImportant' ] as const;
export type StaticFormFieldType = typeof StaticFormFieldTypes[number];

type BaseStaticFormField = BaseFormField & {
    type:StaticFormFieldType,
}

export type StaticTextCustomFormField = BaseStaticFormField & {
    type:'StaticText',
    header:LocalizedText[],
    text:LocalizedText[]
}

export type StaticTextImportantCustomFormField = BaseStaticFormField & {
    type:'StaticTextImportant',
    header:LocalizedText[],
    text:LocalizedText[]
}


// ------------------------------------------
// Shared base for Input fields (values allocated in answer object)

export const InputFormFieldTypes = [ 'RadioButtonColumn', 'RadioButtonRow', 'Suggester', 'FileUpload', 'FreeText', 'CustomComponent', 'MatrixRadioButtons' ] as const;
export type InputFormFieldType = typeof InputFormFieldTypes[number];

export type BaseInputFormField = BaseFormField & {
    
    type:InputFormFieldType,
    
    // Label is the label for fields in overviews cards
    label:string,
    
    // Header is the label for fields in an answer form
    // If not defined, label is used
    header:LocalizedText[],
    
    helpText?:LocalizedText[],

    footer?:LocalizedText[],

    
    isSegmentation?:boolean,
    
    // Can be used for filtering
    isPrimaryField?:boolean,

    defaultValue?:string,

    // Determines if a specific permissionGroup is required to view the field
    permissionGroupFilter?:PermissionGroupId,
    
}

export type BaseFieldOption = {
    value:string,
    numericalValue?:number,
    content:LocalizedText[],
    reportText:string
}